import { ReCaptchaV2Props } from "src/components/recaptcha-v2/ReCaptchaV2";
import { RE_CAPTCHA_KEY } from "./environment-variables";

export const recaptchaV2Options: Omit<ReCaptchaV2Props, "onChange"> = {
  sitekey: RE_CAPTCHA_KEY,
  theme: "dark",
};
